import Base from './Base'
import gsap from 'gsap'
import EmblaCarousel from 'embla-carousel'
import { evt, utils, store } from '@/core'
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()	
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()

		console.log('Producto')
		// Card Swiper
		const swiperCards = qs(".cards-swiper")
		
		swiperCards &&
		new Swiper(swiperCards, {
			spaceBetween:20,
			slidesPerView: 'auto',
			freeMode: true,
			loop:true,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			speed: 6000,
		});
		
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
}